import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ChatshopLogo from 'assets/media/images/Chatshop-long-logo.svg';
import PagiiLogo from 'assets/media/images/Pagii-icon.png';

import LoginLayout from "./login.layout";

import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AuthLoginProps } from "redux/auth/types";
import useRedux from "redux/useRedux";
import { AuthLogin } from "redux/auth";
import "react-toastify/dist/ReactToastify.css";
import { Error } from "@mui/icons-material";



const Login = () => {
  const navigate = useNavigate();
  const {
    thunkDispatch,
    storeState: { Auth },
  } = useRedux();
  //const [isLoginFailed, setIsLoginFailed] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [credentials, setCredentials] = useState<AuthLoginProps>({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(null);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);


  useEffect(() => {
    if (Auth?.data?.data?.isAuthenticated) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Auth]);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleLogin = async (e: any) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (credentials.username === "" || credentials.password === "") {
      setLoginError("Username / Email dan kata sandi wajib diisi");
      return;
    }

    if (!executeRecaptcha) {
      setLoginError("Sistem keamanan belum siap. Silakan coba lagi.");
      return;
    }

    const token = await executeRecaptcha("login");
    if (!token) {
      setLoginError("Validasi sistem keamanan gagal.");
      return;
    }

    setCaptchaToken(token);
    setLoginError(null);

    thunkDispatch(AuthLogin(credentials))
      .unwrap()
      .then((res: any) => {
        if (res && res.status === "error") {
          if (res.data?.metaData?.code === "12003") {
            setLoginError("Silahkan verifikasi email terlebih dahulu");
          } else {
            setLoginError("Username atau kata sandi salah");
          }
        } else {
          toast.success("Login berhasil");
        }
      })
      .catch(() => {
        setLoginError("Terjadi kesalahan sistem. Silakan coba lagi.");
      });
  };

  return (
    <LoginLayout title="Pagii Chatshop - Masuk" fullScreen>
      <ToastContainer />
      <div className="flex h-screen w-full flex-col lg:flex-row overflow-hidden">
        <div className="relative hidden w-full lg:block lg:w-3/5 h-full overflow-hidden shrink-0">
          <img
            src="/login-cover-2.jpeg"
            alt="Login Illustration"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent flex flex-col justify-end p-10 lg:p-16">
            <div className="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl p-6 lg:p-8 shadow-2xl max-w-md">
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="/ic-pagii-chatshop-small.svg"
                  alt="Chatshop Logo"
                  className="h-8 w-auto"
                />
                <span className="text-2xl font-bold text-white tracking-widest ">
                  CHATSHOP
                </span>
              </div>
              <h2 className="text-lg text-white font-medium leading-relaxed ">
                Solusi Terpadu Kelola Bisnis & Percakapan Pelanggan dalam Satu Platform yang Cerdas.
              </h2>
            </div>
          </div>
        </div>


        <div className="flex flex-1 w-full items-center justify-center bg-white p-8 lg:w-2/5 lg:p-12 overflow-y-auto">
          <div className="w-full max-w-md space-y-8">
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
              <div className="flex items-center gap-2.5 mb-8">
                <a href="https://chatshop.pagii.co/" target="_blank" rel="noopener noreferrer">
                  <img
                    src={ChatshopLogo}
                    alt="Chatshop"
                    className="h-12 w-auto"
                  />
                </a>
              </div>

              <h1 className="text-4xl font-bold tracking-tight text-slate-900">
                Masuk
              </h1>
              <p className="mt-2 text-sm text-slate-400">
                Silahkan masuk untuk mengelola toko Anda
              </p>
            </div>

            {loginError && (
              <div
                className="bg-red-50 border-2 border-red-500 text-red-700 px-4 py-3 rounded-lg relative text-sm flex items-center gap-2"
                role="alert"
              >
                {/* <ErrorIcon className="text-xl" /> */}
                <Error className="text-xl" />
                <span className="block sm:inline">{loginError}</span>
              </div>
            )}
            <form onSubmit={handleLogin} className="mt-10 space-y-6">
              <div className="group relative">
                <input
                  id="username"
                  type="text"
                  autoComplete="username"
                  value={credentials.username}
                  onChange={(e) => {
                    setCredentials({
                      ...credentials,
                      username: e.target.value,
                    });
                    setLoginError(null);
                  }}
                  className={`block w-full rounded-lg border-2 bg-transparent px-4 py-3 text-base text-slate-900 placeholder:text-slate-400 focus:border-brand focus:outline-none focus:ring-0 transition-all  ${isSubmitted && credentials.username === ""
                      ? "border-red-500"
                      : "border-slate-200"
                    }`}
                  placeholder="Username / Email"
                />
                <div className="h-4">
                  {isSubmitted && credentials.username === "" && (
                    <p className="mt-1 text-xs text-red-500 ">
                      Username / Email tidak boleh kosong
                    </p>
                  )}
                </div>
              </div>

              <div className="group relative">
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    minLength={8}
                    value={credentials.password}
                    onChange={(e) => {
                      setCredentials({
                        ...credentials,
                        password: e.target.value,
                      });
                      setLoginError(null);
                    }}
                    className={`block w-full rounded-lg border-2 bg-transparent px-4 py-3 text-base text-slate-900 placeholder:text-slate-400 focus:border-brand focus:outline-none focus:ring-0 transition-all   ${isSubmitted && credentials.password === ""
                        ? "border-red-500"
                        : "border-slate-200"
                      }`}
                    placeholder="Kata sandi"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-4 flex items-center text-slate-400 hover:text-brand transition-colors focus:outline-none"
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                      className="h-5 w-5"
                    />
                  </button>
                </div>
                <div className="flex justify-between items-start mt-1">
                  <div className="h-4">
                    {isSubmitted && credentials.password === "" && (
                      <p className="text-xs text-red-500 ">
                        Kata sandi tidak boleh kosong
                      </p>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => navigate("/forgot-password")}
                    className="text-sm font-semibold text-brand hover:text-brand-dark transition-colors focus:outline-none"
                  >
                    Lupa kata sandi?
                  </button>
                </div>
              </div>



              <div className="w-full">
                <button
                  type="submit"
                  className="w-full px-8 rounded-lg bg-brand py-3 text-base font-bold text-white shadow-lg transition-all hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-dark active:scale-[0.98] "
                >
                  Masuk
                </button>

                <div className="fixed bottom-4">
                  <p className="text-xs text-slate-400 flex items-center gap-1">
                    <span>Powered by</span>
                    <a href="https://pagii.co/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-75">
                      <img src={PagiiLogo} alt="Pagii" className="h-4 w-auto inline" />
                    </a>
                  </p>
                </div>
              </div>
            </form>
            <p className="text-sm text-slate-500 text-center lg:text-left">
              Belum punya akun?{" "}
              <button
                type="button"
                onClick={() => navigate("/register")}
                className="font-bold text-brand hover:text-brand-dark transition-colors focus:outline-none"
              >
                daftar sekarang
              </button>
            </p>
          </div>
        </div>
      </div>
    </LoginLayout>
  );
};


const LoginWithReCaptcha = () => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}>
    <Login />
  </GoogleReCaptchaProvider>
);

export default LoginWithReCaptcha;